// Versão: 1.31
// Data..: 2026-10-15
// Entidades de domínio do portal de chamados.
// v1.31: Company ganha contractedSupportHours/supportHourlyRate (horas de suporte
//        contratadas por mês e valor R$/hora excedente — fonte principal do
//        relatório de horas de suporte, com o Contract como fallback).
// v1.30: Tempo de execução (cronômetro automático) — Ticket ganha workStartedAt,
//        executionSeconds, execPausedAt, execPausedMs e execManualPaused (métrica
//        separada do apontamento manual de horas; conta de pausa própria do cronômetro).
// v1.29: Ticket ganha closedAt (quando o chamado foi fechado) — base confiável para
//        o prazo de reabertura pelo cliente (3 dias).
// v1.28: Ponto Eletrônico (hora extra) — PunchKind com 4 eventos
//        (ENTRY/LUNCH_START/LUNCH_END/EXIT), Punch ganha campos de hora extra e
//        cancelamento; DaySummary ganha overtimeMinutes/overtimeReason/
//        overtimeCanceled/endAtConfigured.
// v1.27: Ponto Eletrônico — Punch/TimeclockConfig/AbsenceAttachment/AbsenceJustification/
//        AccountingDeliveryConfig e DaySummary (resumo diário calculado para relatórios).
// v1.26: integração CalDAV ↔ Zimbra — campos caldavUid/caldavEtag/caldavSyncedAt/caldavHref
//        no Ticket (sincronização bidirecional de tarefas) + interface CaldavConfig.
// v1.25: cobrança temporária — OneTimeChargeItem + Contract.oneTimeItems (itens de mês
//        único faturados uma vez e então removidos; competence AAAA-MM alvo, vazio = próxima geração).
// v1.24: merge Frentes D+E — link público de pagamento + expiração/lembretes de assinatura.
// v1.23: QuoteStatus ganha 'expired' — ao vencer o prazo de assinatura o orçamento fica
//        visível como expirado na listagem (motor de expiração promove 'sent' → 'expired').
// v1.22a: expiração/lembretes de assinatura — SignatureStatus 'expired',
//        SignatureRequest.expiresAt, SignatureRecipient.lastReminderAt/reminderCount
//        e Quote.signatureDeadlineDays (prazo padrão da assinatura em dias).
// v1.22: Invoice.paymentToken (token do link público de pagamento — página sem login).
// v1.21: Invoice/InvoiceSendLogEntry (módulo de Faturamento — cobrança/boleto Inter) e
//        Contract.autoSendBilling (envio automático do e-mail de cobrança por contrato).
// v1.10: Company.externalId (id do cliente na origem externa, ex.: GestãoClick).
// v1.11: User.extension (ramal 3CX) e Company.internalExtension (ramal interno).
// v1.12: Contract com campos da GestãoClick (externalId/código/tipo/situação, valor,
//        periodicidade, próximo vencimento) + raw (payload bruto completo importado).
// v1.13: CommercialService (serviço comercial/financeiro) + ContractServiceItem;
//        Contract estruturado e editável (itens de serviço, vendedor, pagamento,
//        plano de contas, centro de custo, dia de vencimento) para migração da
//        gestão de contratos da GestãoClick (base para boleto/NF futuros).
// v1.14: Quote (orçamento/contrato) + QuoteSigner/QuoteLineItem/QuoteStatus —
//        campos variáveis da minuta Makweb, signatários e metadados de assinatura/PDF.
// v1.15: SignatureRequest + SignatureRecipient/SignerState/SignatureStatus —
//        assinatura eletrônica própria (token, trilha de auditoria, PDF selado).
// v1.16: Quote.contractId + Contract.quoteId/signedPdfKey — contrato gerado
//        automaticamente quando o orçamento é assinado por todas as partes.
// v1.17: SignatureRecipient.viewedAt (quando o link foi acessado).
// v1.18: bot de triagem do WhatsApp — WhatsAppBotConfig/Option, WhatsAppBotSession/Step.
// v1.19: bot de triagem vira fluxo configurável — WhatsAppBotFlowStep/StepType (passos
//        ordenáveis: welcome/ask_name/ask_email/message/question/menu/routed); a sessão
//        passa a guardar stepIndex e answers.
// v1.20: DepartmentVisibilityConfig — restrição de visibilidade de chamados por
//        departamento (mapa departmentId → departamentos visíveis), aplicada na listagem.
// Normaliza os níveis de suporte do usuário: usa o array novo (supportLevels) e,
// se ausente, cai para o campo único legado (supportLevel). Sempre retorna um array.
export function getUserSupportLevels(user) {
    if (user.supportLevels?.length)
        return user.supportLevels;
    return user.supportLevel ? [user.supportLevel] : [];
}
//# sourceMappingURL=entities.js.map